import { ChangeEvent } from 'react';
import styles from './InputForm.module.scss';

interface IPropsInputForm {
    isValidField?: boolean;
    typeInput?: string;
    onChangeInput: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    inputName: string;
    placeholder?: string;
    label: string;
    messageError?: string;
    isTextArea?: boolean;
    required?: boolean;
    pattern?: RegExp;
    value?: string;
    customStyles?: string;
}

export default function InputForm({
    isValidField = true,
    typeInput,
    onChangeInput,
    inputName,
    placeholder = '',
    messageError,
    label,
    isTextArea = false,
    required = true,
    value,
    customStyles = '',
}: IPropsInputForm) {
    return (
        <div
            className={`${!isValidField ? styles.error : ''} ${styles.InputContainer} ${customStyles}`}
        >
            <label>
                {label}
                {isTextArea ? (
                    <textarea
                        name={inputName}
                        onChange={onChangeInput}
                        value={value}
                        placeholder={placeholder}
                    />
                ) : (
                    <input
                        type={typeInput}
                        value={value}
                        onChange={onChangeInput}
                        name={inputName}
                        placeholder={placeholder}
                        required={required}
                    />
                )}
                {!isValidField && <p className={styles.validation_msg}>{messageError}</p>}
            </label>
        </div>
    );
}
